import React, { lazy, Suspense } from 'react';

const VideoComponent = lazy(() => import('./VideoBackground'));

const SeaTurtleBG = () => {
    return (
        <div className="">
            <Suspense fallback={<div>Loading...</div>}>

                <div className="absolute top-0 left-0 w-full h-full -z-10">
                    <VideoComponent className="w-full h-full" />
                </div>

            </Suspense >
        </div >
    );
};

export default SeaTurtleBG;
